import { Outlet } from 'react-router-dom';
import { AppLayout } from '@/layout/app-layout';
import { BusinessGuard, ProtectedRoute } from '@/navigation/guards/route-guards';

export function TenantPreviewRouteFrame() {
  return (
    <ProtectedRoute>
      <BusinessGuard>
        <AppLayout />
      </BusinessGuard>
    </ProtectedRoute>
  );
}

export function TenantChromeFreeRouteFrame() {
  return (
    <ProtectedRoute>
      <BusinessGuard>
        <Outlet />
      </BusinessGuard>
    </ProtectedRoute>
  );
}

export function TenantAppRouteFrame() {
  return (
    <ProtectedRoute>
      <BusinessGuard>
        <AppLayout />
      </BusinessGuard>
    </ProtectedRoute>
  );
}
